<template>
  <q-dialog v-model="edit">
    <q-card>
      <q-form @submit="onSubmit" ref="myForm" class="flexbox">
        <div class="q-pa-md">
          <div class="row q-col-gutter-xs">
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Company Name*</span>
              <q-input
                outlined
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                :rules="[val => (val !== null && val !== '') || 'Please type your company name']"
                v-model="name"
              >
                <template v-slot:prepend>
                  <q-icon name="fas fa-user-tie" size="16px" color="grey-7"></q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Package*</span>
              <q-select
                class="customTextColor"
                outlined
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                disable
                :options="packages"
                :rules="[val => val || 'Please select your package']"
                :option-label="item => item.name"
                :option-value="item => item.id"
                v-model="package"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
                <template v-slot:prepend>
                  <q-icon name="fas fa-cubes" size="16px" color="grey-7"></q-icon>
                </template>
              </q-select>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">State*</span>
              <q-select
                class="customTextColor"
                outlined
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                :options="countries"
                :placeholder="placeholderGenerator(state, 'Select State')"
                :rules="[val => !!val || 'Please select your state']"
                map-options
                emit-value
                use-input
                @filter="filterCountries"
                option-label="name"
                option-value="id"
                v-model="state"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
                <template v-slot:prepend>
                  <q-icon name="fas fa-flag" size="16px" color="grey-7"></q-icon>
                </template>
              </q-select>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">City*</span>
              <q-select
                class="customTextColor"
                :disable="loadingCities"
                outlined
                ref="city"
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                :rules="[val => !!val || 'Please select your city']"
                :loading="loadingCities"
                @filter="filterCities"
                :placeholder="placeholderGenerator(city, 'Select City')"
                :options="cities"
                option-label="name"
                option-value="id"
                v-model="city"
                map-options
                emit-value
                use-input
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
                <template v-slot:prepend>
                  <q-icon name="fas fa-city" size="16px" color="grey-7"></q-icon>
                </template>
              </q-select>
            </div>
            <div class="col-md-12 col-xs-12 col-lg-12">
              <span class="label-input">Address*</span>
              <q-input
                class="customTextColor"
                type="textarea"
                ref="email"
                outlined
                lazy-rules
                v-model="address"
                color="grey-7"
                label-color="grey-7"
                :rules="[val => (val !== null && val !== '') || 'Please type your address']"
              >
                <template v-slot:prepend>
                  <q-icon name="fas fa-map-marker-alt" size="16px" color="grey-7"></q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">ZIP Code*</span>
              <q-input
                type="number"
                outlined
                lazy-rules
                v-model="zip"
                color="grey-7"
                label-color="grey-7"
                :rules="[val => (val !== null && val !== '') || 'Please type zip code']"
              >
                <template v-slot:prepend>
                  <q-icon name="fas fa-at" size="16px" color="grey-7"></q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Lease calculating period*</span>
              <q-select
                class="customTextColor"
                outlined
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                :options="lease_calculating_periods"
                :rules="[val => val || 'Please select your period']"
                :option-label="item => item.name"
                :option-value="item => item.value"
                v-model="lease_calculating_period_type"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">TSD Company ID</span>
              <q-input
                outlined
                type="number"
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                v-model="tsd_company_id"
              >
              </q-input>
            </div>
          </div>
            <div class="mt-5 flex-end q-gutter-xs">
              <q-btn :loading="loading" label="Save" type="submit" color="positive">
                <template v-slot:loading>
                  <q-spinner-facebook />
                </template>
              </q-btn>
            </div>
        </div>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from '../axios/index'
export default {
  data() {
    return {
      loading: false,
      loadingCities: false,
      address: '',
      name: '',
      city: null,
      state: null,
      package: {},
      zip: '',
      states: [],
      cityByState: [],
      cities: [],
      countries: [],
      lease_calculating_period_type: 'monthly',
      tsd_company_id: null,
      lease_calculating_periods: [
        { name: 'Monthly', value: 'monthly' },
        { name: 'Daily', value: 'daily' }
      ]
    }
  },
  mounted() {
    this.getStates()
  },
  methods: {
    async onSubmit() {
      try {
        this.loading = true
        const body = {
          name: this.name,
          state: this.state,
          city: this.city,
          address: this.address,
          zip: this.zip,
          lease_calculating_period_type: this.lease_calculating_period_type?.value || 'monthly',
          tsd_company_id: this.tsd_company_id === '' || this.tsd_company_id === undefined ? null : this.tsd_company_id
        }
        const { data } = await axios.patch(`company/${this.selectedCompany.id}`, body)
        this.$store.commit('company/SET_UPDATE_COMPANY', {
          name: this.name,
          state: this.countries.find(item => item.id === this.state),
          city: this.cities.find(item => item.id === this.city),
          address: this.address,
          id: this.selectedCompany.id,
          package: this.selectedCompany.package,
          lease_calculating_period_type: this.lease_calculating_period_type?.value || 'monthly',
          tsd_company_id: this.tsd_company_id === '' || this.tsd_company_id === undefined ? null : this.tsd_company_id,
          created_at: this.selectedCompany.created_at,
          updated_at: this.selectedCompany.updated_at,
          zip: this.zip
        })
        const newVal = {
          name: this.name,
          state: this.state,
          city: this.city,
          address: this.address,
          id: this.selectedCompany.id,
          package: this.selectedCompany.package,
          lease_calculating_period_type: this.lease_calculating_period_type?.value || 'monthly',
          tsd_company_id: this.tsd_company_id === '' || this.tsd_company_id === undefined ? null : this.tsd_company_id,
          created_at: this.selectedCompany.created_at,
          updated_at: this.selectedCompany.updated_at,
          zip: this.zip
        }
        this.$store.commit('location/SET_CHECK_EDIT_COMPANY', newVal)
        this.$store.commit('vehicle/SET_CHECK_EDIT_COMPANY', newVal)
        this.$store.commit('profit/SET_CHECK_EDIT_COMPANY', newVal)
        this.$q.notify({
          message: 'Company updated successfully',
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        this.edit = false
      } catch (error) {
        const errors = error.response?.data?.errors || 'Something went wrong'
        let message = ''
        function errorHandler(obj) {
          for (const key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
              const element = obj[key]
              if (Array.isArray(element)) {
                message = element[0]
              } else if (typeof element === 'object') {
                errorHandler(element)
              } else {
                message = element
              }
            }
          }
        }
        if (error.response?.data?.code === 404) {
          message = error.response?.data?.message
        } else if (error.response?.data?.code === 422) {
          errorHandler(errors)
        } else if (error.response?.data?.code === 401) {
          message = 'Not have Authority to make changes'
        }
        this.$q.notify({
          message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.loading = false
      }
    },
    async getCities(id) {
      try {
        const { data } = await axios.get(`cities/${id}`)
        this.cities = data.data
        this.cityByState = data.data
      } catch (error) {
      } finally {
      }
    },
    async getStates() {
      try {
        this.loadingCities = true
        const { data } = await axios.get('states')
        this.states = data.data
        this.countries = data.data
      } catch (error) {
      } finally {
        this.loadingCities = false
      }
    },
    async handlerEvent(id) {
      if (this.countries.length === 0) await this.getStates()
      await this.getCities(id)
    },
    reset() {
      this.selectedCompany = {}
      this.address = ''
      this.name = ''
      this.state = ''
      this.id = ''
      this.city = ''
      this.package = ''
      this.zip = ''
      // Set to the 'monthly' object from the lease_calculating_periods array
      this.lease_calculating_period_type = this.lease_calculating_periods.find(period => period.value === 'monthly') || this.lease_calculating_periods[0]
      this.tsd_company_id = null
    },
    setCompanyToComponent() {
      this.address = this.selectedCompany.address
      this.name = this.selectedCompany.name
      this.state = this.selectedCompany.state.id
      this.id = this.selectedCompany.id
      this.city = this.selectedCompany.city.id
      this.package = this.selectedCompany.package
      this.zip = this.selectedCompany.zip
      // Find the matching period object based on the value from API
      const periodValue = this.selectedCompany.lease_calculating_period_type
      const periodObject = this.lease_calculating_periods.find(period => period.value === periodValue)
      this.lease_calculating_period_type = periodObject || this.lease_calculating_periods[0]
      this.tsd_company_id = this.selectedCompany.tsd_company_id
    },
    placeholderGenerator(val, text) {
      const typeOfValue = typeof val
      if (typeOfValue === 'string') {
        return val ? '' : text
      } else if (typeOfValue === 'object') {
        return val?.id ? '' : text
      }
    },
    filterCountries(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.countries = this.states.filter(v => v.name.toLowerCase().indexOf(needle) > -1)
      })
    },
    filterCities(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.cities = this.cityByState.filter(v => v.name.toLowerCase().indexOf(needle) > -1)
      })
    }
  },
  computed: {
    selectedCompany: {
      get() {
        return this.$store.state.company.selectedCompany
      },
      set(val) {
        this.$store.commit('company/SET_SELECTED_COMPANY', val)
      }
    },
    edit: {
      get() {
        return this.$store.state.company.edit
      },
      set(val) {
        this.$store.commit('company/SET_EDIT', val)
      }
    },
    packages() {
      return this.$store.state.company.packages
    }
  },
  watch: {
    edit(n, o) {
      if (!n) {
        this.reset()
      } else {
        this.setCompanyToComponent()
      }
    },
    state: {
      deep: true,
      handler(n, o) {
        if (n) {
          this.getCities(n)
          if (this.$store.state.company.selectedCompany.state.id !== n) {
            this.city = null
            this.getStates()
          }
          this.$refs.city && this.$refs.city.resetValidation()
        } else {
          this.getStates()
          this.cities = []
          this.city = null
        }
      }
    }
  }
}
</script>
